// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mp-page-grid {
    display: grid;
    grid-template-areas: 
        "top top" 
        "middle right";
    grid-template-rows: 80px auto;  /* Header + Content */
    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
    max-height: 1000vh;
    display: flex;
    flex-direction: column;
    height: 1000px;
    width: 1200px;
    gap: 15px;
    place-items: center;
    background-color: rgb(208, 183, 183);
    box-shadow:  0px 0px 0px 1px darkslategray;
  }

  .mp-page-grid-upper {
    /* margin-left: 40px; */
    min-height: 180px;
    height: auto;
    width: 100%;
    box-shadow:  1px 1px 3px 0px white;
  }
  
  .mp-page-grid-lower {
    background: none;
    min-height: 100vh;
    width: 100%;
    max-width: 1250px;
    min-width: 1000px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 10px;
    margin-top: -20px;
    overflow-y: auto;
    z-index: 1000;
  }

    /* Responsive Design */
    @media (max-width: 900px) {
        .page-grid {
          grid-template-areas:
            "top"
            "middle"
            "left"
            "right";
          grid-template-columns: 1fr;
          grid-template-rows: 80px auto auto auto;
        }
      }
      `, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/MemberProfilePage.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb;;sBAEkB;IAClB,6BAA6B,GAAG,qBAAqB;IACrD,6CAA6C,EAAE,mCAAmC;IAClF,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,oCAAoC;IACpC,0CAA0C;EAC5C;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;IAEE,sBAAsB;IACtB;QACI;UACE;;;;mBAIS;UACT,0BAA0B;UAC1B,uCAAuC;QACzC;MACF","sourcesContent":["\n.mp-page-grid {\n    display: grid;\n    grid-template-areas: \n        \"top top\" \n        \"middle right\";\n    grid-template-rows: 80px auto;  /* Header + Content */\n    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n    max-height: 1000vh;\n    display: flex;\n    flex-direction: column;\n    height: 1000px;\n    width: 1200px;\n    gap: 15px;\n    place-items: center;\n    background-color: rgb(208, 183, 183);\n    box-shadow:  0px 0px 0px 1px darkslategray;\n  }\n\n  .mp-page-grid-upper {\n    /* margin-left: 40px; */\n    min-height: 180px;\n    height: auto;\n    width: 100%;\n    box-shadow:  1px 1px 3px 0px white;\n  }\n  \n  .mp-page-grid-lower {\n    background: none;\n    min-height: 100vh;\n    width: 100%;\n    max-width: 1250px;\n    min-width: 1000px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    margin-top: -20px;\n    overflow-y: auto;\n    z-index: 1000;\n  }\n\n    /* Responsive Design */\n    @media (max-width: 900px) {\n        .page-grid {\n          grid-template-areas:\n            \"top\"\n            \"middle\"\n            \"left\"\n            \"right\";\n          grid-template-columns: 1fr;\n          grid-template-rows: 80px auto auto auto;\n        }\n      }\n      "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
